<template>
	<Page>
		<BaseTypography tag="h1" weight="semi-bold" size="xxl">Apps</BaseTypography>

		<!-- <div v-if="latestApps.length > 0">
			<div v-for="app in latestApps" :key="app._id">
				<img :src="app.bannerUrl" class="card-avatar" />
			</div>
		</div> -->

		<div class="tag-list">
			<div
				v-for="tag in tags"
				:key="tag"
				class="tag"
				:class="{ 'tag-selected': currentTag === tag }"
				@click="currentTag = tag"
			>
				{{ tag }}
			</div>
		</div>

		<div v-for="app in filteredApps" :key="app._id" class="card" @click="open(app)">
			<img :src="app.bannerUrl" class="card-avatar" />
			<div class="card-body">
				<div class="card-title">{{ app.name }}</div>
				<div class="card-tag-list">
					<div v-for="tag of app.tags" :key="tag" class="card-tag">{{ tag }}</div>
				</div>
			</div>
		</div>
	</Page>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import Page from '@/components/ui/Page.vue';
import { useBackendApi } from '@/services/useBackendApi';
import { computed } from 'vue';
import type { IApp } from '@/api/backend/types';
import { useStorage } from '@vueuse/core';
import { useTelegram } from '@/composables/useTelegram';
import BaseTypography from '@/components/ui/BaseTypography.vue';

const backendApi = useBackendApi();
const { telegram } = useTelegram();

const currentTag = ref<string>('All');
const latestAppsIds = useStorage<Set<string>>('latest-apps-ids', new Set());

const apps = await backendApi.Appcatalog.apps();
const latestApps = computed(() => {
	const obg = Object.fromEntries(apps.map((app) => [app._id, app]));

	return Array.from(latestAppsIds.value.values()).map((appId) => obg[appId]);
});

const filteredApps = computed(() =>
	currentTag.value === 'All' ? apps : apps.filter((app) => app.tags.includes(currentTag.value!))
);

const tags = apps.reduce((prev, cur) => {
	cur.tags.forEach((tag) => prev.add(tag));
	return prev;
}, new Set<string>(['All']));

const open = (app: IApp) => {
	latestAppsIds.value.add(app._id);

	if (app.url.startsWith('https://t.me/')) telegram?.WebApp.openTelegramLink(app.url);
	else telegram?.WebApp.openLink(app.url);
};
</script>

<style scoped>
.tag-list {
	display: flex;
	flex-direction: row;
	gap: var(--size-xs);
}

.tag {
	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 8px 10px;
	gap: 6px;

	background: #0d1325;
	border-radius: 8px;

	cursor: pointer;

	font-family: 'Exo 2';
	font-style: normal;
	font-weight: 400;
	font-size: 12px;
	line-height: 120%;

	color: #99a1b7;
}

.tag-selected {
	background: #222b46;

	color: #ffffff;
}

.card {
	box-sizing: border-box;

	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 8px 12px;
	gap: 16px;

	background: linear-gradient(
		83.45deg,
		rgba(2, 122, 255, 0.05) -1.65%,
		rgba(248, 254, 255, 0.05) 52.48%,
		rgba(2, 122, 255, 0.05) 104.15%
	);
	border-radius: 16px;

	cursor: pointer;

	font-family: 'Exo 2';
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	line-height: 120%;

	color: rgba(255, 255, 255, 0.7);

	border: 1px solid rgba(255, 255, 255, 0.1);
}

.card-tag-list {
	display: flex;
	flex-direction: row;
	/* gap: var(--size-xs); */
}

.card-tag {
	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 2px 8px 4px;
	gap: 6px;

	background: #252f4a;
	border-radius: 8px;

	font-family: 'Exo 2';
	font-style: normal;
	font-weight: 400;
	font-size: 10px;
	line-height: 120%;

	color: #99a1b7;
}

.card-avatar {
	width: 60px;
	height: 60px;
	aspect-ratio: 1;

	border-radius: 12px;
}

.card-body {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	padding: 0px;
	gap: 8px;
}

.card-title {
	/* padding: var(--size-xs); */
}
</style>
